<template>
    <div class="page-class">
        <div class="page-wrapper">
            <div class="page-content"
                v-if="isAccountLoaded">
                <nav-bar-logo
                    class="history-nav"
                    :userType="userType"></nav-bar-logo>
                <tab-sub-menu
                    :lblTab="lbl.history.tabbar"
                    :theme="userType"
                    tabActive="used"></tab-sub-menu>
                <div class="page-burn-list">
                    <burn-list
                        :lbl="lbl"
                        :localeCode="localeCode"
                        :controller="modalController"
                    ></burn-list>
                </div>
                <tab-bar
                    :lblTab="lbl.tabbar"
                    :theme="userType"
                    tabActive="history"></tab-bar>
            </div>
            <div class="page-bg page-bg-white"></div>
        </div>

        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
//basic
//import Vue from 'vue';
//import Util from '@/helper/Utility.js';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import NavBarLogo from "@/components/Layout/NavBar/NavBarLogo.vue";
import TabBar from "@/components/Layout/TabBar/TabBar.vue";
import TabSubMenu from "../component/TabSubMenu.vue";
import BurnList from "../component/BurnList.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { SerialModalController } from "@/components/Modal/Controller/SerialModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";

export default {
    name: 'burnlist',
    mixins: [
        AccountMixin,
        LocaleMixin
    ],
    components: {
        ModalMaster,
        NavBarLogo,
        TabBar,
        TabSubMenu,
        BurnList,
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            serialModal: new SerialModalController(),
            loadingModal: new LoadingModalController(),
            confirmModal: new ConfirmModalController(),
        };
    },
    created: function() {
        this.serialModal.setLoadingModal(this.loadingModal);
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setSerialModal(this.serialModal);
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setConfirmModal(this.confirmModal);

    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
@import "@/module/History/page/BurnListPage.scss";
</style>
